module.exports = __webpack_public_path__ + "../resources/images/illustration_search_folder-1ad2ef6aa2fd64fab3310edfbf56e566.svg";